import { Trans } from '@lingui/macro'
import { Box, Link, Typography } from '@mui/material'
import { RootStateOrAny, useSelector } from 'react-redux'

export const PrivacyPolicy = (): React.ReactElement => {
  const language = useSelector((state: RootStateOrAny) => state.user.language)

  return (
    <Box
      display='flex'
      flexDirection='row'
      gap={2}
      sx={theme => ({
        textAlign: 'left',
        padding: '14px 40px 17px 40px',
        [theme.breakpoints.down(1440)]: {
          padding: '14px 24px 17px 24px'
        }
      })}
    >
      <Typography
        sx={{
          color: '#000',
          textAlign: 'center',
          fontFamily: 'Open Sans',
          fontSize: '13px',
          fontWeight: 400,
          lineHeight: '25px'
        }}
      >
        <Trans>
          ALL_RIGHTS_RESERVED_TEXT
        </Trans>
      </Typography>

      <Link
        component='a'
        href={
          language === 'fr'
            ? 'https://centre.support/fr/politique-de-confidentialite/'
            : 'https://centre.support/privacy-policy/'
        }
        target='_blank'
        rel='noopener noreferrer'
        style={{
          textAlign: 'center',
          fontFamily: 'Open Sans',
          fontSize: '13px',
          fontWeight: 700,
          lineHeight: '25px'
        }}
      >
        <Trans>
          PRIVACY_POLICY_TEXT
        </Trans>
      </Link>
    </Box>
  )
}
